import { ExpireProcessingResults, UpdateResultsStatus } from '../session/results.actions';
import { UpdateScanStatus } from '../scanner/scanner.actions';
import { Observable, of, timer } from 'rxjs';
import { PollingActions } from './polling.actions';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { inject, Injectable } from '@angular/core';
import { delay, switchMap, takeUntil } from 'rxjs/operators';

@Injectable()
export class PollingEffects {
  private actions$ = inject(Actions);


  interval = 10000;
  expirationDelay = 5000;

  beginPolling$: Observable<Action> = this.actions$.pipe(
    ofType(PollingActions.BEGIN_POLLING)
  );

  endPolling$: Observable<Action> = this.actions$.pipe(
    ofType(PollingActions.END_POLLING)
  );

  endPollingOnDelay$: Observable<Action> = this.endPolling$.pipe(
    delay(this.interval),
  );

  pollScans$: Observable<Action> = createEffect(() => this.beginPolling$.pipe(
    switchMap(() => {
      return timer(0, this.interval).pipe(
        takeUntil(this.endPolling$),
      );
    }),
    switchMap(() => of(new UpdateScanStatus()))
  ));

  pollDocuments$: Observable<Action> = createEffect(() => this.beginPolling$.pipe(
    switchMap(() => {
      return timer(0, this.interval).pipe(
        takeUntil(this.endPollingOnDelay$),
      );
    }),
    switchMap(() => of(new UpdateResultsStatus()))
  ));

  // this effect isn't expected to be triggered by a dispatched action of its own
  expireProcessingResults$: Observable<Action> = createEffect(() => this.endPollingOnDelay$.pipe(
    delay(this.expirationDelay),
    switchMap(() => of(new ExpireProcessingResults())),
  ));

}
